import type { ApolloError } from '@apollo/client';

export const isLoginError = (error: ApolloError | undefined) =>
  error?.message === 'Response not successful: Received status code 401';
